import { BouColor } from './bou-colors';
import { color as d3color } from 'd3-color';

export function getHoverColor(color?: string, hoverTheme: 'lighter' | 'darker' = 'lighter') {
  if (!color) {
    return BouColor.TOOL_TEXT_DARK_GRAY;
  }
  if (hoverTheme === 'lighter') {
    return d3color(color)?.brighter(5).formatHex();
  }
  return d3color(color)?.darker(5).formatHex();
}
